// import Pricing from '@siteminder/pricing-api'

export default {
    init() {
      // JavaScript to be fired on all pages
      $(function () {
        // Header navbar menu
        $('.navbar.navbar-regions li.menu-item-has-children a:first-child:nth-last-child(2)').addClass('dropdown-toggle').attr({
          id: 'navbarDropdown',
          role: 'button',
          'aria-haspopup': 'true',
          'aria-expanded': 'false',
        }).append('<svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-chevron-down ml-2" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/></svg>');
        $('.navbar.navbar-regions .menu-item-has-children').hover(
          function () {
            $(this).addClass('show');
            $(this).children('.sub-menu').addClass('show');
            $(this).children('.dropdown-toggle').attr('aria-expanded', 'true');
          },
          function () {
            $(this).removeClass('show');
            $(this).children('.sub-menu').removeClass('show');
            $(this).children('.dropdown-toggle').attr('aria-expanded', 'false');
          });
        $('.navbar.navbar-regions .nav > li.menu-item-has-children > .sub-menu').addClass('row justify-content-center dropdown-menu border-0').attr('aria-labelledby', 'navbarDropdown');
        $('.navbar.navbar-regions .menu-list--right ul, .navbar.navbar-regions .menu-list--left ul').removeClass('sub-menu').addClass('row  pl-0');
        $('.navbar.navbar-regions .menu-list--left a:first-child:nth-last-child(2), .navbar.navbar-regions .menu-list--right a:first-child:nth-last-child(2)').addClass('d-none');
        });
    },
    finalize() {
      // JavaScript to be fired on all pages, after page specific JS is fired
    },
  };
  


// WEBPACK FOOTER //
// ./scripts/routes/categoryTestimonials.js